import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'

import Main from '../views/Main.vue'
import newsHome from '../views/newsHome/newsHome.vue'

const routes = [
  {
    path: '/',
    name: 'Main',
    component: Main,
    redirect: '/Home',
    meta:{},
    children:[
      {
        path: '/Home',
        name: 'Home',
        component: () => import('@/views/Home'),
        meta: { 
          title: '首页',
          keepAlive: true,
        },
      },
      {
        path: '/details',
        name: 'details',
        component: () => import('@/views/details'),
        meta: { 
          title: '详情',
          keepAlive: false,
        },
      },
      {
        path: '/test_center',
        name: 'test_center',
        component: () => import('@/views/test_center'),
        meta: { 
          title: '考试中心',
          keepAlive: false,
        },
      },
      {
        path: '/projectpolicy',
        name: 'projectpolicy',
        component: () => import('@/views/projectpolicy'),
        meta: { 
          title: '项目政策',
          keepAlive: false,
        },
      },
      {
        path: '/announcement',
        name: 'announcement',
        component: () => import('@/views/announcement'),
        meta: { 
          title: '公告通知',
          keepAlive: false,
        },
      },
      {
        path: '/candidates_service',
        name: 'candidates_service',
        component: () => import('@/views/candidates_service'),
        meta: { 
          title: '考生服务',
          keepAlive: false,
        },
      },
      {
        path: '/organization',
        name: 'organization',
        component: () => import('@/views/organization'),
        meta: { 
          title: '内设机构',
          keepAlive: false,
        },
      },
      {
        path: '/chair_forum',
        name: 'chair_forum',
        component: () => import('@/views/chair_forum'),
        meta: { 
          title: '论坛讲座',
          keepAlive: false,
        },
      },
      {
        path: '/problem',
        name: 'problem',
        component: () => import('@/views/problem'),
        meta: { 
          title: '常见问题',
          keepAlive: false,
        },
      },
      {
        path: '/about_us',
        name: 'about_us',
        component: () => import('@/views/about_us'),
        meta: { 
          title: '关于我们',
          keepAlive: false,
        },
      },
      
    ]

  },
  {
    path: '/newsHome',
    name: 'newsHome',
    component: newsHome,
    redirect: '/newsHome/news',
    meta:{},
    children:[
      {
        path: 'news',
        name: 'news',
        component: () => import('@/views/newsHome/news'),
        meta: { 
          title: '首页',
          keepAlive: true,
        },
      },
      {
        path: 'Details',
        name: 'Details',
        component: () => import('@/views/newsHome/Details'),
        meta: { 
          title: '详情',
          keepAlive: true,
        },
      },
      {
        path: 'Lists',
        name: 'Lists',
        component: () => import('@/views/newsHome/Lists'),
        meta: { 
          title: '列表',
          keepAlive: true,
        },
      },
      {
        path: 'search',
        name: 'search',
        component: () => import('@/views/newsHome/search'),
        meta: { 
          title: '搜索',
          keepAlive: true,
        },
      },
      {
        path: 'AboutAssociation',
        name: 'AboutAssociation',
        component: () => import('@/views/newsHome/AboutAssociation'),
        meta: { 
          title: '协会',
          keepAlive: true,
        },
      },
    ]

  },

  {
    path: '/Login',
    name: 'Login',
    component: () => import('@/views/Login'),
    meta: { 
      title: '登录',
      keepAlive: true,
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/register'),
    meta: { 
      title: '注册',
      keepAlive: true,
    },
  },
]
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location)
}
Vue.use(VueRouter)

const router = new VueRouter({
  routes
})
// 页面刷新时，重新赋值token
// if (window.localStorage.getItem('token')) {
//   store.dispatch("setToken",window.localStorage.getItem('token'));
// }

router.beforeEach(async(to, from, next) => {
  // to要进入的目标路由;from离开的路由
  //判断是否需要缓存
  if(to.path == from.path ){
    // 让 列表页 即不缓存，刷新
    to.meta.keepAlive = false; 
  }
  next()
})


export default router
